import React from 'react';
import Label from '../../Core/InputLabel';
import SimpleSelect from '../../Core/SimpleSelect';
import DateRangePicker from '../../Core/DateRangePicker';
import Tooltip from '../../Core/Tooltip';

export default function filterActivity({
  style, inputValues,
  handleInputChange, places, t, employees, actions,
}) {
  return (
    <div className={style.filterBlock}>
      <div className={style.formControl}>
        <div className={style.filterBlock__date}>
          <DateRangePicker
            initRange={inputValues.from}
            onChange={handleInputChange}
          />
        </div>
      </div>
      <div className={style.formControl}>
        <Label text={t('Employee')} />
        <div className={style.selectBlock}>
          <SimpleSelect
            handleInputChange={handleInputChange}
            name='employee'
            placeholder={t('Select employee')}
            value={inputValues.employee}
            options={employees}
            valueKey='id'
            labelKey='fullName'
          />
        </div>

      </div>
      <div className={style.formControl}>
        <Label text={t('Place')} />
        <div className={style.selectBlock}>
          <SimpleSelect
            handleInputChange={handleInputChange}
            name='place'
            placeholder={t('Select Place')}
            value={inputValues.place}
            options={places}
            valueKey='id'
            labelKey='name'
          />
        </div>
      </div>
      <div className={style.formControl}>
        <div className={style.flex}>
          <Label text={t('Action')} />
          <div style={{paddingBottom: 7}}>
            <Tooltip title={
              <div>
                <div>{t('Login: Employee logged in')}</div>
                <div>{t('Logout: Employee logged out')}</div>
                <div>{t('Added User Role: New user role added')}</div>
                <div>{t('Deleted User Role: User role has been deleted')}</div>
                <div>{t('Role Changed: Employee role changed')}</div>
                <div>{t('Changed PIN Code: Kiosk user PIN code has been changed')}</div>
                <div>{t('Employee Updated: Employee has been updated')}</div>
                <div>{t('Clocked In: Employee clocked in')}</div>
                <div>{t('Clocked Out: Employee clocked out')}</div>
                <div>{t('Added Account: Added new account')}</div>
                <div>{t('Deleted Account: Account has been deleted')}</div>
              </div>
            } />
          </div>
        </div>
        <div className={style.selectBlock}>
          <SimpleSelect
            handleInputChange={handleInputChange}
            name='action'
            placeholder={t('Select Action')}
            value={inputValues.action}
            options={actions}
            valueKey='id'
            labelKey='name'
          />
          
        </div>
      </div>
    </div>
  );
}
